import { NudosFileInput } from '../NudosComponents';
import './BillingPurchaseUploader.scss';

interface BillingPurchaseOrderUploaderProps {
  customClassName?: string;
  uploadProofOfPurchase: (file: string | Blob | File | any) => void;
  loading: boolean;
  proofOfPurchase?: string;
}
const BillingPurchaseUploader = ({
  customClassName,
  uploadProofOfPurchase,
  loading,
  proofOfPurchase
}: BillingPurchaseOrderUploaderProps) => {
  const downloadDocument = (url: string) => {
    if (url) {
      window.open(url, '_blank');
    }
  };
  return (
    <div className={`billingPurchaseUploader ${customClassName || ''}`}>
      <div className="containerUploader">
        <NudosFileInput
          uploadedFileHandler={uploadProofOfPurchase}
          buttonText={proofOfPurchase ? 'Documento Cargado' : 'Cargar documento'}
          isFilled={!!proofOfPurchase}
          color="orange"
          isLoading={loading}
          isDisabled={loading}
          customWidth="280px"
        />
      </div>
      <div
        className={`downloadProofPurchase ${!!proofOfPurchase ? 'existUrl' : 'noUrl'}`}
        onClick={() => downloadDocument(proofOfPurchase || '')}
      >
        Descargar documento
      </div>
    </div>
  );
};

export default BillingPurchaseUploader;
